import { Component } from '@angular/core';
import { LexbeDoc } from '@models/doc.model';
import { DocViewerStore } from '@store/legacy/doc-viewer.store';
import { distinctUntilChanged, merge, switchMap, takeUntil, tap, withLatestFrom } from 'rxjs';
import { BaseComponent } from 'src/app/components/base.component';
import { DocNote } from './doc-note.model';
import { FormControl, Validators } from '@angular/forms';

@Component({
    selector: 'lex-doc-note-panel',
    templateUrl: './doc-note-panel.component.html',
    styleUrls: ['./doc-note-panel.component.scss'],
    standalone: false
})
export class DocNotePanelComponent extends BaseComponent {
	public currentDocumentSnapshot: LexbeDoc;
	public currentDocNotesLoaded = false;
	public latestDocNote: DocNote = null;
	public noteControl: FormControl;
	private initExistingNote: boolean = false;
	constructor(
		private docViewerStore: DocViewerStore,
	) {
		super();

		this.noteControl = new FormControl();
		this.noteControl.setValidators([
			Validators.maxLength(8000),
			Validators.pattern("[^<>]*")]);

		const reset$ = this.docViewerStore.reset$.pipe(
			switchMap(() => this.docViewerStore.currentDocument$)
		);

		const docChange$ = this.docViewerStore.currentDocument$.pipe(
			distinctUntilChanged((a, b) => a.docId === b.docId)
		);

		merge(
			reset$,
			docChange$
		).pipe(
			withLatestFrom(this.docViewerStore.simpleState$, this.docViewerStore.docNotesEdits$),
			tap(([doc, currentState, note]) => {
				this.currentDocumentSnapshot = doc;
				this.clearSelected();

				this.latestDocNote = new DocNote();
				this.latestDocNote.docNote = '';

				if (currentState.hasUnsavedNotes) {
					this.latestDocNote = note;
				} else if (currentState.notes?.length > 0) {
					const filteredList = currentState.notes.filter(n => !n.isPrivate);
					if (filteredList.length > 0) {
						const sortedList = filteredList.sort((a, b) => Date.parse(a.dateTimeCreated) - Date.parse(b.dateTimeCreated));
						this.latestDocNote = sortedList.pop();
						this.initExistingNote = true;
					}
				}

				this.noteControl.setValue(this.latestDocNote.docNote);
				this.noteControl.updateValueAndValidity();
				this.noteControl.markAsPristine();
			}),
			takeUntil(this.destroy$)
		).subscribe();

		this.noteControl.valueChanges.subscribe((value) => {
			if (!this.initExistingNote && this.latestDocNote && value !== this.latestDocNote.docNote) {
				this.latestDocNote.docNote = value;
				this.markEditorAsDirty(this.latestDocNote);
			} else if (this.initExistingNote)
				this.initExistingNote = false;
		});
	}

	public clearSelected(): void {
		this.latestDocNote = null;
		this.noteControl?.reset();
	}

	private markEditorAsDirty(note: DocNote): void {
		this.docViewerStore.updateDocNotesEditSource(note);
		this.docViewerStore.updateState((currentState) => {
			currentState.hasUnsavedNotes = true;
			return currentState;
		});
	}
}
